import { generatedAPI } from '@grafana/api-clients/rtkq/iam/v0alpha1';

export const iamAPIv0alpha1 = generatedAPI.enhanceEndpoints({});

// eslint-disable-next-line no-barrel-files/no-barrel-files
export * from '@grafana/api-clients/rtkq/iam/v0alpha1';
